// extracted by mini-css-extract-plugin
export default {"retour":"page_retour__gtLuM","wrapper":"page_wrapper__9EMcL"};